import FormCellInput from 'components/FormCellInput.jsx';
import Formsy from 'lib/Formsy';
import Glyph from 'components/Glyph.jsx';
import Invitation from 'entities/Invitation';
import React, { Component } from 'react';
import RecipientParser from 'lib/RecipientParser';

class ParticipantsTableInputRow extends Component {
  static propTypes = {
    groupId: React.PropTypes.number.isRequired,
    name: React.PropTypes.string,
    namePlaceholder: React.PropTypes.string,
    uid: React.PropTypes.string,
    uidPlaceholder: React.PropTypes.string,
    validateInitialValues: React.PropTypes.bool,
    onValidityChange: React.PropTypes.func.isRequired,
    onChange: React.PropTypes.func.isRequired,
    serverErrors: React.PropTypes.object,
    parsePasteWith: React.PropTypes.func,
    autofocus: React.PropTypes.bool,
  };

  static defaultProps = {
    name: '',
    uid: '',
    serverErrors: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      warning: null,
    };
  }

  componentWillMount() {
    if (this.props.validateInitialValues) {
      this.validateBothInputs(this.props.name, this.props.uid);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.validateInitialValues) {
      this.validateBothInputs(nextProps.name, nextProps.uid);
    }
    if (!nextProps.name && !nextProps.uid) {
      this.setState({ warning: null, uidError: null });
    }
  }

  onNameChange = (event) => {
    // When changing the name, if the uid and name are both empty, clear errors and warning
    const name = event.target.value;
    if (!name && !this.props.uid) {
      this.setState({ warning: null, uidError: null });
    }

    this.setState({ warning: null });
    this.props.onChange('name', event);

    const rowValid = (this.uidValid(name, this.props.uid) === true) && !this.state.uidError;
    this.props.onValidityChange(rowValid);
  };

  onNameBlur = (uid) => {
    uid = uid || this.props.uid;

    if (!this.props.name && !uid) {
      this.setState({ warning: null, uidError: null });
    } else {
      if (!this.nameValid(this.props.name, uid)) {
        this.setState({
          warning: 'If no name is entered, participants will be asked for ' +
          'their names before they’re added to your class.',
        });
      } else {
        this.setState({ warning: null });
      }
    }
  };

  onUidChange = (event) => {
    const uid = event.target.value;
    if (!uid && !this.props.name) {
      this.setState({ warning: null });
    } else if (uid) {
      this.onNameBlur(uid);
    }

    this.setState({ uidError: null });
    this.props.onChange('uid', event);

    const valid = this.uidValid(this.props.name, uid) === true;
    if (valid) {
      this.serverValidateUid(uid);
    }

    this.props.onValidityChange(valid);
  };

  onUidBlur = () => {
    this.onNameBlur();
    if (!this.props.name && !this.props.uid) {
      this.setState({ warning: null, uidError: null });
    } else {
      const error = this.uidValid(this.props.name, this.props.uid);
      if (error !== true) {
        this.setState({ uidError: error });
      } else {
        this.serverValidateUid(this.props.uid);
      }
    }
  };

  serverValidateUid(uid) {
    if (!uid) {
      return;
    }

    const parsedUid = RecipientParser.newToken(uid).address;
    this.validateUid(parsedUid).catch((response) => {
      let serverError = '';
      for (let recipient in response) {
        recipient = response[recipient];
        if (recipient.error) {
          serverError = recipient.error.recipient[0];
          break;
        }
      }
      this.setState({ uidError: serverError });
      this.props.onValidityChange(false);
    });
  }

  validateUid(uid) {
    return Invitation.isValidGroupInvite(this.props.groupId, uid);
  }

  nameValid(name, uid) {
    return Formsy.customValidators.isPresentIfUidIsPresent({ name, uid }, name);
  }

  uidValid(name, uid) {
    return Formsy.customValidators.isEmailOrPhoneOrFormIsEmpty({ name, uid }, uid);
  }

  validateBothInputs(name, uid) {
    if (!this.nameValid(name, uid)) {
      this.setState({
        warning: 'Participants without names will be asked for ' +
        'their name before being added to your class.',
      });
    }

    const uidError = this.uidValid(name, uid);
    if (uidError !== true) {
      this.setState({ uidError });
    }

    this.props.onValidityChange(this.uidValid(name, uid) === true);
  }

  renderTableRowValidationGlyph() {
    return (
      <button tabIndex="-1" type="button">
        <Glyph color="flame" name="caution" solo />
      </button>
    );
  }

  render() {
    return (
      <Formsy.Form
        className="TableInput-body-row">
        <span className="TableInput-cell--validation TableInput-cell">
          {this.state.warning && this.renderTableRowValidationGlyph()}
        </span>
        <span className="TableInput-body-cell TableInput-cell">
          <FormCellInput
            parsePasteWith={this.props.parsePasteWith}
            name="name"
            autofocus={this.props.autofocus}
            value={this.props.name}
            onBlur={this.onNameBlur}
            onChange={this.onNameChange}
            placeholder={this.props.namePlaceholder}
            errorMessage={this.props.serverErrors.name}
            warningMessage={this.state.warning}
          />
        </span>
        <span className="TableInput-body-cell TableInput-cell">
          <FormCellInput
            parsePasteWith={this.props.parsePasteWith}
            name="uid"
            value={this.props.uid}
            onBlur={this.onUidBlur}
            onChange={this.onUidChange}
            placeholder={this.props.uidPlaceholder}
            errorMessage={this.props.serverErrors.uid || this.state.uidError}
          />
        </span>
      </Formsy.Form>
    );
  }
}

export default ParticipantsTableInputRow;



// WEBPACK FOOTER //
// ./src/users/components/ParticipantsTableInputRow.jsx